"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrapFocus = void 0;

var _react = require("react");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getKeyboardFocusableElements = function getKeyboardFocusableElements() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  var elements = container.querySelectorAll('a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])');
  return Array.from(elements).filter(function (el) {
    return !el.hasAttribute('disabled');
  });
};

var useTrapFocus = function useTrapFocus(_ref, params) {
  var containerRef = _ref.containerRef;
  (0, _react.useEffect)(function () {
    var container = containerRef.current;

    if (!container) {
      return;
    }

    var focusableElements = getKeyboardFocusableElements(container);

    if (focusableElements.length === 0) {
      return;
    }

    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var target = null;

    var handleFocusIn = function handleFocusIn(_ref2) {
      var relatedTarget = _ref2.relatedTarget;

      if (relatedTarget && !target) {
        target = relatedTarget;
      }
    };

    var handleKeyDown = function handleKeyDown(event) {
      var isTabPressed = event.key === 'Tab';

      if (!isTabPressed) {
        return;
      }

      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
      }
    };

    var handleFocusOut = function handleFocusOut(_ref3) {
      var relatedTarget = _ref3.relatedTarget;

      if (!relatedTarget && target) {
        target.focus();
      }
    };

    container.addEventListener('focusin', handleFocusIn, {
      once: true
    });
    container.addEventListener('focusout', handleFocusOut);
    container.addEventListener('keydown', handleKeyDown);
    firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
    return function () {
      container.removeEventListener('focusout', handleFocusOut);
      container.removeEventListener('focusin', handleFocusIn);
      container.removeEventListener('keydown', handleKeyDown);
    };
  }, [containerRef.current].concat(_toConsumableArray(params)));
};

exports.useTrapFocus = useTrapFocus;